module.exports = __webpack_public_path__ + "img/gc1.bb9cb666.png";